import { createSlice } from "@reduxjs/toolkit";
import { changeStates } from "services/messages/messages";

const initialState = {
    msg : {
        data: [],
        isLoading: false,
        isSuccess: false,
        errorMessage: ''
    }
}

export const updateMessagesSlice = createSlice({
    name: 'updateMessages',
    initialState,
    extraReducers: {
        [changeStates.pending]: (state) => {
            state.msg.isLoading = true;
        },
        [changeStates.fulfilled]: (state, { payload }) => {
            state.msg.isLoading = false;
            state.msg.isSuccess = true;
            state.msg.data = payload;
        },
        [changeStates.rejected]: (state, { payload }) => {
            state.msg.isLoading = false;
            state.msg.isSuccess = false;
            state.msg.errorMessage = payload
        }
    }
})

export default updateMessagesSlice.reducer;